
import Back from './breadcrumb'
import BaseInput from './base-input'
import BaseSelete from './base-selete'
import BaseTextarea from './base-textarea'
import AddressCascader from './address-cascader'
import DatePicker from './date-picker'
import HeadImg from './head_img'
import ImagePreview from './image-preview'

let components = {
    Back,  // 面包屑，现在只有返回
    BaseInput,  // 该系统的封装的输入框
    BaseSelete,  // 单选框
    BaseTextarea,  // 输入域
    AddressCascader, // 多级连的地址选择器
    DatePicker,  // 时间选择器
    HeadImg, // 用户头像
    ImagePreview, // 大图预览
}

export default {
    install: function(Vue) {
        for (let i in components) {
            components[i].install(Vue)
        }
    }
}